import { render } from "./CustomTagsAIModal.vue?vue&type=template&id=557bfcc0&scoped=true"
import script from "./CustomTagsAIModal.vue?vue&type=script&lang=js"
export * from "./CustomTagsAIModal.vue?vue&type=script&lang=js"

import "./CustomTagsAIModal.vue?vue&type=style&index=0&id=557bfcc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557bfcc0"]])

export default __exports__